import styled from "styled-components";

export const Wrap = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 22px 28px 0;
`;

export const Card = styled.div`
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  overflow: hidden;
  background: ${(p) => p.theme.tokens.colors.surface};
  box-shadow: 0 12px 32px rgba(16, 32, 27, 0.1);
`;

export const Cover = styled.div`
  position: relative;
  height: 188px;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(11, 92, 78, 0.1), rgba(11, 92, 78, 0.55));
  }
`;

export const InfoPanel = styled.div`
  display: flex;
  gap: 18px;
  align-items: flex-end;
  padding: 18px 24px 20px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Avatar = styled.div`
  width: 92px;
  height: 92px;
  margin-top: -56px;
  flex-shrink: 0;
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  overflow: hidden;
  border: 4px solid ${(p) => p.theme.tokens.colors.surface};
  box-shadow: 0 10px 24px rgba(16, 32, 27, 0.18);
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NameRow = styled.div`
  line-height: 1.15;
`;

export const Name = styled.h1`
  display: inline;
  margin: 0;
  font-weight: 900;
  font-size: 26px;
  letter-spacing: -0.6px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const StatusPill = styled.span<{ $open: boolean }>`
  margin-left: 12px;
  vertical-align: middle;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${(p) => (p.$open ? "#E7F8EF" : p.theme.tokens.colors.softBg)};
  color: ${(p) => (p.$open ? "#11935F" : p.theme.tokens.colors.muted)};
  font-weight: 800;
  font-size: 12.5px;
  padding: 6px 12px;
  border-radius: 999px;
`;

export const StatusDot = styled.span<{ $open: boolean }>`
  width: 7px;
  height: 7px;
  border-radius: 4px;
  background: ${(p) => (p.$open ? "#1FB877" : p.theme.tokens.colors.muted)};
  box-shadow: ${(p) => (p.$open ? "0 0 0 3px rgba(31, 184, 119, 0.2)" : "none")};
`;

export const Tagline = styled.div`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 4px;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 11px;
  flex-wrap: wrap;
`;

export const MetaDot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 2px;
  background: #cbd5d1;
`;

export const MetaItem = styled.span<{ $clickable?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-weight: 700;
  font-family: ${(p) => p.theme.tokens.font.family};
  border: none;
  background: none;
  padding: 0;
  cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
  ${(p) => (p.$clickable ? "text-decoration: underline; text-underline-offset: 3px;" : "")}
`;
